import i18n from 'helpers/i18n';
import messages from './messages';
import { Section } from '../Styled';
import { Icon } from 'semantic-ui-react';
import React, { useContext } from 'react';
import { addIndex, isEmpty, map } from 'ramda';
import TimeZone from 'components/TimeZone';
import Typography from 'components/Typography';
import { Text } from '@teachstonellc/component-library';
import TrainingContext from '../TrainingContext';
import { formatSession } from './utils';
import { Session } from 'types/api/Session';
import { SessionCard, SessionList } from './Styled';

const Sessions: React.FC = () => {
  const { training } = useContext(TrainingContext);
  const sessions: Session[] = training.sessions;

  if (isEmpty(sessions)) {
    return null;
  }

  return (
    <Section>
      <Text as="h2" className="block text-base font-bold text-[#00779E]">
        <Icon name="calendar" />
        {i18n.ft(messages.sessionDates)}
      </Text>

      <TimeZone />

      <SessionList>
        {addIndex<Session>(map)((session, idx) => {
          return (
            <SessionCard key={session.id}>
              <Typography bold size="large">
                {i18n.ft(messages.sessionNumber, { number: idx + 1 })}
              </Typography>
              <Typography display="block">{formatSession(session)}</Typography>
            </SessionCard>
          );
        }, sessions)}
      </SessionList>
    </Section>
  );
};

export default Sessions;
